import type { Ref } from 'preact';

export interface I_WidgetHeaderProps {
  closeWidget: () => void;
  closeButtonRef: Ref<HTMLButtonElement>;
}

export enum E_ActiveView {
  MAIN = 'main',
  POST_REGISTRATION = 'post-registration',
  REDEMPTION = 'redemption',
  FLEXIBLE_POINTS = 'flexible-points',
}
